// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"68337d68","125":"02a90e75","248":"5aec56c0","334":"a1208c0d","496":"16aee783","811":"5aec56c0","929":"be5f6c2c"}[chunkId] + ".chunk.css";
};